import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

import './../pages/home.css'
import logodecor2 from '../assets/decor.svg'
import HeadingBlock from '../components/common/heading';
import sec2img from '../assets/sec2img.png'
import Button from '../components/common/button';
import decor2 from '../assets/decoricon01.svg'
import decor3 from '../assets/decoricon02.svg'


const HomeS2 = () => {

    const [section, setSection] = useState(null);

    useEffect(() => {
        const getSection = async () => {
            const { data, error } = await supabase
                .from('section')
                .select('*')
                .eq('id', 1)
                .single();

            if (error) {
                console.log(" error:", error);
                return;
            }
            setSection(data);
        };

        getSection();
        
    }, []);

    if (!section) return null;

    return (
        <section className='section2'>
            <div className='homeS2Cont'>
                <HeadingBlock 
                    style1="dark left floatIn scrollAnimate"
                    heading={section.title}
                    img={logodecor2}  
                />
            <img  aria-hidden="true" className='homeS2Decor1 float' src={decor2} alt="" />
            <img  aria-hidden="true" className='homeS2Decor2 float' src={decor3} alt="" />

                <p>{section.description}</p>

                <Button 
                    style1="size2 beige" 
                    cta="Book my ticket" 
                    link="/booking" 
                />
            </div>

            <div className="sec2imgCont">
                <img className='moveIn scrollAnimate2' 
                    src={section.image} 
                    alt="Decorative Weavery beautfully displayed in pink, blue and teal colors" 
                />
            </div>
        </section>
    );
}

export default HomeS2;